import { AxiosResponse } from 'axios';

export async function handleAxiosResponse<R>(
  response: Promise<AxiosResponse<R>>
): Promise<R> {
  // add additional handlers here
  const { data } = await response;
  return data;
}
